import React from 'react';
import { getFeature } from '@utils';
import PropTypes from 'prop-types';
import Link from '@components/base_link/component';
import Text from '@components/ui_text/component';
import Space from '@components/ui_space/component';
import './styles.scss';

const QandA = (props) => {
  const { product } = props;
  const { isActive } = getFeature('qAndA');
  if (!isActive) {
    return null;
  }

  const formattedPersons = product.persons.map((person, i) => {
    let seperator;
    switch (i) {
    case 0:
      seperator = '';
      break;
    case product.persons.length - 1:
      seperator = ' en ';
      break;
    default:
      seperator =  ', ';
    }
    return (
      <span key={`person-${i}`}>
        {seperator}
        <Link
          href={person.url}
        >
          {person.name}
        </Link>
      </span>
    );
  });

  return (
    <div className="qa">
      <Space size={5}/>
      { !!product.releaseDate && (
        <>
          {product.offered === 2 && product.expectedDate ? (
            <span>
              <h2><Text replacements={{ productName: product.name }}>pdp.qa.question.releasedate.future</Text></h2>
              <p><Text replacements={{ productName: product.name, releaseDate: product.expectedDate }}>pdp.qa.answer.releasedate.future</Text></p>
            </span>
          ) : (
            <span>
              <h2><Text replacements={{ productName: product.name }}>pdp.qa.question.releasedate.past</Text></h2>
              <p><Text replacements={{ productName: product.name, releaseDate: product.releaseDate }}>pdp.qa.answer.releasedate.past</Text></p>
            </span>
          )}
        </>
      )}
      {!!product.persons.length && (
        <span>
          <h2><Text replacements={{ productName: product.name }}>pdp.qa.question.author</Text></h2>
          <p><Text replacements={{ productName: product.name }}>pdp.qa.answer.author</Text> {formattedPersons}.</p>
        </span>
      )}
    </div>
  );
};

QandA.propTypes = {
  product: PropTypes.object,
};
export default QandA;
